import { Roboto } from 'next/font/google';
import { createTheme } from '@mui/material/styles';
import { red, grey } from '@mui/material/colors';

export const roboto = Roboto({
  weight: ['300', '400', '500', '700'],
  subsets: ['latin'],
  display: 'swap',
  fallback: ['Helvetica', 'Arial', 'sans-serif'],
});

// Create a theme instance.
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(255, 255, 255)',
    },
    secondary: {
      main: '#19857b',
    },
    white: {
      main: '#ffffff',
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: roboto.style.fontFamily,
  },
  components: {
    MuiSwitch: {
      styleOverrides: {
        root: {
          // Overrides here
        },
        track: {
          backgroundColor: grey[300], // Light grey track
        },
        thumb: {
          color: grey[50], // White thumb
          '&.Mui-checked': {
            color: '#ffffff', // White when checked
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: grey[300], // Keep light grey when ON
          }
        }
      }
    }
  }
});

export default theme;
